import { sha256 } from '@noble/hashes/sha256';
import { bytesToHex } from '@noble/hashes/utils';
import type { SignedFile, SignatureManifest } from '@slate/plugin-api';

const enc = new TextEncoder();

export function sha256Hex(bytes: Uint8Array): string {
  return bytesToHex(sha256(bytes));
}

/** Files sorted by path (ASCII/code-point), "path\n sha256\n" each. */
export function canonicalFilesString(files: SignedFile[]): string {
  return [...files]
    .sort((a, b) => (a.path < b.path ? -1 : a.path > b.path ? 1 : 0))
    .map((f) => `${f.path}\n${f.sha256}\n`)
    .join('');
}

export function recomputeContentHash(files: SignedFile[]): string {
  return sha256Hex(enc.encode(canonicalFilesString(files)));
}

export function canonicalMessage(sig: SignatureManifest): string {
  return (
    'slate-plugin-sig:v1\n' +
    `id=${sig.id}\n` +
    `version=${sig.version}\n` +
    `keyId=${sig.keyId}\n` +
    `contentHash=${sig.contentHash}\n`
  );
}

export function base64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
